import { render, staticRenderFns } from "./organization-info-form.vue?vue&type=template&id=8ea1fb4e&"
import script from "./organization-info-form.vue?vue&type=script&lang=js&"
export * from "./organization-info-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports